import React, { useState } from 'react'
import { Route } from 'react-router-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import {
  Navbar,
  NavbarToggler,
  Button,
  Collapse,
} from 'reactstrap'
import Articles from '../Articles/Articles'
import NewReleases from '../NewReleases/NewReleases'
import About from '../About/About'
import BookDetail from '../BookDetail/BookDetail'
import VoicesSeries from '../Books/VoicesSeries'
import Contact from '../Contact/Contact'
import Home from '../Home/Home'
import Navigation from '../Navigation/Navigation'
import books from '../../data/book-data'
import News from '../News/News'
import Header from '../Header/Header'
import Footer from '../Footer/Footer'

function AppRouter() {
  const [collapsed, setCollapsed] = useState(true)
  
  const toggle = () => {
    setCollapsed(!collapsed)
  }
  
  const closeNav = () => {
    if (!collapsed) {
      toggle()
    }
  }
  
  const bookDetail = routeProps => {
    const { title } = routeProps.match.params
    const book = books.find(b => b.title === title)
    return <BookDetail {...book } />
  }
  
  return (
    <Router>
      <Header/>
      <Navbar className="mt-0 mx-auto mb-5 d-flex align-items-center justify-content-center" light expand="md">
        <NavbarToggler className="align-self-center" tag={() => (<Button className="navbar-toggler" color="link" onClick={ toggle }>Menu</Button>)}/>
        <Collapse className="text-center mt-2" isOpen={ !collapsed } navbar>
          <Navigation toggle={ closeNav } />
        </Collapse>
      </Navbar>
      <main>
        <Route path="/" exact component={Home}/>
        <Route path="/about" exact component={About}/>
        <Route path="/new-releases" exact component={NewReleases}/>
        <Route path="/articles" exact component={Articles}/>
        <Route path="/voices-series" exact component={VoicesSeries}/>
        <Route path="/contact" exact component={Contact}/>
        <Route path="/news" exact component={News}/>
        <Route path="/books/:title" render={ bookDetail }/>
      </main>
      <Footer/>
    </Router>
  )
}

export default AppRouter
